"use client";

import { useState, createContext, useContext } from 'react';

const FreeServiceContext = createContext<any>(null);

export const FreeServiceProvider = ({ children }: { children: React.ReactNode }) => {
    const [isServiceFree, setServiceFree] = useState(false);

    return (
        <FreeServiceContext.Provider value={{ isServiceFree, setServiceFree }}>
            {children}
        </FreeServiceContext.Provider>
    );
};

export const useFreeService = () => {
    const context = useContext(FreeServiceContext);
    if (!context) {
        throw new Error('useFreeService must be used within a FreeServiceProvider');
    }
    return context;
};